import styled from 'styled-components';
export const Wrapper = styled.div `
  position: sticky;
  top: ${({ $offset }) => `${$offset}px`};
`;
